import { API, graphqlOperation } from 'aws-amplify';
import { updateApplicant_companyInformation } from 'src/graphql/customized_mutations';
import { getAp_CompanyInformation } from 'src/graphql/customized_queries';
import axios from 'axios';
import { environment, url } from 'src/environments';

export const reqSatCompany = async (body) => {
  try {
    const response = await axios.post(`${url}/${environment}/satws/credit-analysis/autofill`, body);
    return response.data;
  } catch (error) {
    console.error('Error in reqSatCompany:', error);
    throw error;
  }
};
